import { Api, Queue } from "@/plugins/api"

export const deleteAllOfType = (sasId, codeInfraction) => {
  Queue.enqueue(() => Api.post('sas-antecedents-judiciaires/delete-all-of-type/' + sasId, { codeInfraction: codeInfraction }))
}